import { useState, useContext } from "react";
import API from "api/api";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { AppContext } from "context/AppContext";
import { useTranslation, Trans } from "react-i18next";

import { Colors, Spacing } from "@paclife/plds.tokens";
import { useFlags } from "launchdarkly-react-client-sdk";
import Select from "react-select";
import Typography from "common/Typography/Typography";


const Wrapper = styled.div`
    display: flex;
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
    white-space: nowrap;
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;

const PhoneSelect = styled(Select)`
    display: block;
    width: 60%;
    min-width: 200px;
`;

const PhoneChangeMsg = styled(Typography)`
    margin-top: ${Spacing[8]};
    display: block;
`;

const EditMessage = styled(Typography)`
    margin-top: ${Spacing[8]};
    display: block;

    a {
        font-weight: bold;
    }
`;


const Phone = ({ selected, options }) => {
    const { t } = useTranslation("notification");
    const { 
        fetchProfileData
      } = useContext(AppContext);
    const defaultMessage = t(`notification:phone.typeLabel`);
    const [phoneMessage, setPhoneMessage] = useState(defaultMessage);
    const [selectedNumber, setSelectedNumber] = useState(selected);
    const { rsdUpReadonlyaccessEn } = useFlags();

    const handlePhoneNumberChange = async(e) => {
	 if (rsdUpReadonlyaccessEn) {
            return;
        }
        selectedNumber.value = e.value;
        selectedNumber.label = e.value;
        const reqBody = { phoneNumber: e.value };   
        const response = await API.updateNotificationPhone(reqBody);
        if (!response.succeed) {
            setSelectedNumber(selected);
        }
        fetchProfileData()
        setPhoneMessage(response.message);
        setTimeout(() => {
            setPhoneMessage(defaultMessage);
          }, "4000");
    }

    return (
        <div>
            <Wrapper>
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            Phone
                        </Text>
                    </Label>
                    <PhoneSelect
                        className="notification-phone"                                              
                        onChange={e => handlePhoneNumberChange(e)}
                        options={options}
                        value={selectedNumber}                        
                    />
                    <PhoneChangeMsg variant="microcopy">{phoneMessage}</PhoneChangeMsg>

                    <EditMessage variant="microcopy">
                        <Trans i18nKey="notification:phone.securityTabLink">
                            <Link to="/security" />
                        </Trans>
                    </EditMessage>
                </div>
            </Wrapper>            
        </div>
    );
};

export default Phone;